const GetNextDates = (daysToAdd, startDate = new Date()) => {
	let arrDates = [];

	const MonthAsString = (monthIndex) => {
		let month = new Array();
		month[0] = {
			number: '01',
			full: 'january',
		};
		month[1] = {
			number: '02',
			full: 'february',
		};
		month[2] = {
			number: '03',
			full: 'march',
		};
		month[3] = {
			number: '04',
			full: 'april',
		};
		month[4] = {
			number: '05',
			full: 'may',
		};
		month[5] = {
			number: '06',
			full: 'june',
		};
		month[6] = {
			number: '07',
			full: 'july',
		};
		month[7] = {
			number: '08',
			full: 'august',
		};
		month[8] = {
			number: '09',
			full: 'september',
		};
		month[9] = {
			number: '10',
			full: 'october',
		};
		month[10] = {
			number: '11',
			full: 'november',
		};
		month[11] = {
			number: '12',
			full: 'december',
		};

		return month[monthIndex];
	};

	const DayAsString = (dayIndex) => {
		let weekdays = new Array(7);
		weekdays[0] = {
			full: 'sunday',
			short: 'sun',
		};
		weekdays[1] = {
			full: 'monday',
			short: 'mon',
		};
		weekdays[2] = {
			full: 'tuesday',
			short: 'tue',
		};
		weekdays[3] = {
			full: 'wednesday',
			short: 'wed',
		};
		weekdays[4] = {
			full: 'thursday',
			short: 'thu',
		};
		weekdays[5] = {
			full: 'friday',
			short: 'fri',
		};
		weekdays[6] = {
			full: 'saturday',
			short: 'sat',
		};

		return weekdays[dayIndex];
	};

	for (let i = 0; i <= daysToAdd - 1; i++) {
		const today = new Date();
		const currentDate = new Date();
		currentDate.setDate(startDate.getDate() + i);

		const date = currentDate.getDate(),
			month = currentDate.getMonth() + 1,
			year = currentDate.getFullYear();
		let obj = {
			day: DayAsString(currentDate.getDay()),
			date,
			month,
			year,
			fullDate: date + '/' + month + '/' + year,
		};

		obj.today = today.getDate() === currentDate.getDate() && 'today';

		today.setDate(today.getDate() + 1);

		obj.tomorrow = today.getDate() === currentDate.getDate() && 'tomorrow';

		arrDates.push(obj);
	}

	return arrDates;
};

export default GetNextDates;
